/**
 * 获取Master 数据的api地址
 */
let apiDefine = {}

apiDefine['progress'] = '/data/getDivisionList'
apiDefine['quoteStatuslist'] = '/data/getQuoteStatusList'
apiDefine['BUIKBList'] = '/data/getBUIKBList'
apiDefine['CSTPYCNDList'] = '/data/getCSTPYCNDList'
apiDefine['ESTPRKBList'] = '/data/getESTPRKBList'
apiDefine['TITPRTList'] = '/data/getTITPRTList'
apiDefine['checkList'] = '/data/getCheckList'
apiDefine['checkListTwo'] = '/data/getCheckListTwo'
apiDefine['estrusList'] = '/data/getEstrusList'
apiDefine['progressList'] = '/data/getProgressList'
apiDefine['statusList'] = '/data/getStatusList'
apiDefine['rateList'] = '/data/getRateList'
apiDefine['goodsList'] = '/data/getGoodsList'
apiDefine['orderClassifyList'] = '/data/getOrderClassifyList'
apiDefine['businessFormList'] = '/data/getBusinessFormList'
apiDefine['typeList'] = '/data/getTypeList'
apiDefine['jtwrkkbList'] = '/data/getjtwrkkbList'
apiDefine['billPlanMonthFlgList'] = '/data/getBillPlanMonthFlgList'
apiDefine['depositPlanMonthCdList'] = '/data/getDepositPlanMonthCdList'
apiDefine['priceZeroClassList'] = '/data/getpriceZeroClassList'
apiDefine['stereotypesList'] = '/data/stereotypesList'
apiDefine['controlFile'] = '/api/mcmctp'
apiDefine['workMonthList'] = '/data/getWorkMonthList'
apiDefine['workDayList'] = '/data/getWorkDayList'
apiDefine['workSpecCdList'] = '/data/getWorkSpecCdList'
apiDefine['itemDetailCdList'] = '/data/getItemDetailCdList'

export default apiDefine
